import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NotificationsComponent } from 'app/layout/common/notifications/notifications.component';
import { SharedModule } from 'app/shared/shared.module';
import { TsButtonModule, TSIconModule } from 'tsui';

@NgModule({
  declarations: [NotificationsComponent],
  imports: [
    RouterModule,
    OverlayModule,
    PortalModule,
    MatIconModule,
    MatTooltipModule,
    SharedModule,
    TSIconModule,
    TsButtonModule,
    MatProgressSpinnerModule,
    TSIconModule,
  ],
  exports: [NotificationsComponent],
})
export class NotificationsModule {}
